<template>

  <v-row justify="center">

    <v-dialog
      v-model="dialog_show"
      persistent
      max-width="290"
    >

      <v-card>
        <v-card-title class="headline">
          {{dialog_title}}
        </v-card-title>
        <v-card-text>
          {{dialog_summary}}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="green darken-1"
            text
            @click="dialog_show = false"
          >
            {{ $t('ok') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialog_confirm"
      persistent
      max-width="290"
    >

      <v-card>
        <v-card-title class="headline">
          {{dialog_title}}
        </v-card-title>
        <v-card-text>
          {{dialog_summary}}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="green darken-1"
            text
            @click="confirm_dialog_method()"
          >
            {{ $t('ok') }}
          </v-btn>
          <v-btn
            color="green darken-1"
            text
            @click="dialog_confirm = false"
          >
            {{ $t('cancel') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar
      v-model="toast_snackbar"
      :timeout="toast_timeout"
    >
      {{ toast_text }}

      <template v-slot:action="{ attrs }">
<!--        <v-btn-->
<!--          color="blue"-->
<!--          text-->
<!--          v-bind="attrs"-->
<!--          @click="toast_snackbar = false"-->
<!--        >-->
<!--          بستن-->
<!--        </v-btn>-->
      </template>
    </v-snackbar>

  </v-row>
</template>



<script>

  import {bus} from '../main.js'
  export default {
    name: 'TheContainer',
    components: {
    } ,data () {
      return {
        dialog_confirm : false,
        dialog_confirm_tag : false,
        dialog_show : false,
        dialog_title: '',
        dialog_summary : '',

        toast_snackbar : false,
        toast_timeout : -1,
        toast_text : '',

      }
    },
    mounted() {
      bus.$on('show_dialog', (name) => {
        // console.log('bus dialog', name)
        this.dialog_show = true;
        this.dialog_title = name[0];
        this.dialog_summary = name[1];

        // setTimeout(this.load = name , 1000)
      })
      bus.$on('show_confirm_dialog', (name) => {
        // console.log('bus dialog', name)
        this.dialog_confirm = true;
        this.dialog_title = name[0];
        this.dialog_summary = name[1];
        this.dialog_confirm_tag = name[2];

        // setTimeout(this.load = name , 1000)
      })
      bus.$on('show_toast', (name) => {
        // console.log('bus toast', name)
        this.toast_snackbar = true;
        this.toast_timeout = name[0];
        this.toast_text= name[1];
        // setTimeout(this.load = name , 1000)
      })
    },
    methods:{
      confirm_dialog_method(){
        bus.$emit(this.dialog_confirm_tag+"_confirm",true);
        this.dialog_confirm  = false;
      }
    }
  }
</script>
